<template>
  <v-app dark class="gradient tw-relative">
    <div class="dy-bg"></div>
    <div class="tw-z-10 tw-flex tw-flex-col tw-justify-between tw-min-h-[100vh]">
      <div class="tw-w-full tw-mx-auto " style="filter: none !important">
        <div>
          <Header></Header>
        </div>
        <div class="tw-w-full md:tw-w-[92%] tw-mx-auto tw-relative mb-14 tw-px-4">
          <main :class="` tw-min-w-[320px] tw-rounded-md bg-main`">
            <slot></slot>
          </main>
        </div>
      </div>
      <slot name="footer"></slot>
    </div>
    <BanDialog></BanDialog>
  </v-app>
</template>

<script>
import { mapState } from "vuex";
import BanDialog from "../components/dialogs/BanDialog.vue";
import Header from "../components/Header.vue";
export default {
  components: {
    Header,
    BanDialog,
  },
  computed: {
    ...mapState("game", ["playBackground"]),
    isPlayRoute() {
      return this.$route.name == "Play";
    },
  },
  methods: {
    backgroundUrl(type = "default") {
      return this.playBackground || type == "default" ? this.playBackground : require("@/assets/images/background.jpg");
    },
  },
};
</script>

<style scoped>
.gradient {
  /* background: linear-gradient(0deg, rgb(114, 104, 76) 0%, rgb(124, 113, 83) 0%, rgba(41, 39, 38, 1) 100%) !important; */
  background: #133063;
}
.dy-bg {
  background-size: cover;
  filter: blur(5px);
  right: 0;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 1;
}
.bg-main {
  /* background: linear-gradient(180deg, #0a0a0f 0%, #0e0e10 100%); */
}
.play-glow {
  box-shadow: 0px 14px 30px 0px rgba(255, 255, 255, 0.4);
}
</style>
